
module.exports = {
		// universal active state
		a :  'active',
		abs : 'position-absolute',
		fxd : 'position-fixed',
		
		f : 'focus',
		loaded : 'loaded',
		
		inited : 'inited',
		animating : 'animating'
}



/** WEBPACK FOOTER **
 ** ./src/js/models/Global.classes.js
 **/